import { inject } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { catchError, Observable, of } from 'rxjs';
import { StorageConnectionsService } from '../services/storage-connections.service';
import { StorageConnection } from '@definitions/storage/storage';

export const storageConnectionResolverFn = (
	route: ActivatedRouteSnapshot
): Observable<StorageConnection> => {
	const connectionsSvc = inject(StorageConnectionsService);
	const connectionId = route.paramMap.get('connectionId');

	return !isNaN(connectionId as any)
		? connectionsSvc.find(connectionId).pipe(catchError(() => of(null)))
		: of(null);
};
